import { render, staticRenderFns } from "./myCert.vue?vue&type=template&id=151ec4fe&scoped=true&"
import script from "./myCert.vue?vue&type=script&lang=js&"
export * from "./myCert.vue?vue&type=script&lang=js&"
import style0 from "./myCert.vue?vue&type=style&index=0&id=151ec4fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ec4fe",
  null
  
)

export default component.exports